import React from 'react';
import { Wrapper, FooterWrapper } from './styled';
import { HeaderResponsive, HeaderFeature } from '@app/src/common/header';
import { CoverPage, SectionProduct } from '@app/src/views/Home/listProducts';

export const ListProducts:React.FC = () => (
  <React.Fragment>
    <HeaderResponsive />
    <HeaderFeature navBar />
    <Wrapper>
      <CoverPage />
      <SectionProduct />
      <FooterWrapper isDisplay />
    </Wrapper>
  </React.Fragment>
);

ListProducts.displayName = 'ListProducts';
